import React from 'react'
import PropTypes from 'prop-types'
import { detectEnterPress } from '../../../utils/enterPress'
import { validateEmail } from '../../../utils/validateEmail'
import { SubmitButton } from '../../shared/buttons'
import { withToastManager } from 'react-toast-notifications';
import "../styles/SubscribeForm.sass"
import prose from '../../../assets/prose'
import KajabiSubscribeEmbed from "./KajabiSubscribeEmbed";

const SUBSCRIPTION_FLAG = 'khalil-stemmler-newsletter-subscription'

class SubscribeForm extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      isSubmitting: false,
      isSubmittingSuccess: false,
      isSubmittingFailure: false,
      email: '',
      firstName: '',
      alreadySubscribed: false
    }

    this.changeFormSubmissionStatus = this.changeFormSubmissionStatus.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.checkIfAlreadySubscribed = this.checkIfAlreadySubscribed.bind(this);
  }

  checkIfAlreadySubscribed = () => {
    if (typeof localStorage !== "undefined") {
      const sub = localStorage.getItem(SUBSCRIPTION_FLAG);
      if (sub) {
        this.setState({ ...this.state, alreadySubscribed: true })
      } else {
        this.setState({ ...this.state, alreadySubscribed: false })
      }
    }
  }

  componentDidMount = () => {
    this.checkIfAlreadySubscribed();
  }

  setLocalStorageSubscribed = () => {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(SUBSCRIPTION_FLAG, JSON.stringify({ subscribed: true }));
      this.checkIfAlreadySubscribed();
    }
  }

  clearSubscriptionFromLocalStorage = () => {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem(SUBSCRIPTION_FLAG)
      this.checkIfAlreadySubscribed();
    }
  }

  changeFormSubmissionStatus = (isSubmitting, isSubmittingSuccess, isSubmittingFailure) => {
    this.setState({
      ...this.state,
      isSubmitting,
      isSubmittingSuccess,
      isSubmittingFailure
    })
  }

  submitForm = async () => {
    const { toastManager } = this.props;
    if (this.isFormValid()) {

      const { email, firstName } = this.state;
      this.changeFormSubmissionStatus(true, false, false)
      try {
        // This component now renders the Kajabi embed form instead of submitting here.
        // Keeping the legacy code path disabled so we don't double-submit.
        this.changeFormSubmissionStatus(false, false, false);
        toastManager.add(`Please use the form below to subscribe.`, {
          appearance: 'info',
          autoDismiss: true,
        });
      } catch (err) {
        console.error(err);
        this.changeFormSubmissionStatus(false, false, true)

        toastManager.add(`Hmm, that didn't work...`, {
          appearance: 'failure',
          autoDismiss: true,
        });
      }
    }
  };

  onFormFieldChanged = (fieldName, newValue) => {
    this.setState({
      ...this.state,
      [fieldName]: newValue
    })
  }

  isFormValid = () => {
    const { toastManager } = this.props;
    const { email, firstName } = this.state;
    let formValid = true;

    if (firstName === "" || firstName === undefined) {
      formValid = false;
    }

    if (email === "" || email === undefined || !validateEmail(email)) {
      formValid = false;
    }

    if (!formValid) {
      toastManager.add(`Whoops. Want to try that again with a valid email? 🤠`, {
        appearance: 'error',
        autoDismiss: true,
      });
    }

    return formValid;
  }

  onKeyUp = (e) => {
    if (detectEnterPress(e)) {
      this.submitForm();
    } 
  }
  

  render () {
    const { message, buttonText } = this.props;
    const { alreadySubscribed } = this.state;
    return (
      <div 
        className="subscribe-form-container">
          
        <p>
          {message ? message : `
            Join ${prose.subscriberCount}+ value-creating Software Essentialists getting actionable advice on how to master what matters each week. 🖖`
          }
        </p>
        
        { alreadySubscribed ? (
          <>
          <p>✅ Subscribed</p>
          <div 
            onClick={(e) => this.clearSubscriptionFromLocalStorage()} 
            className="resend-link">Use a different email? Resend?
          </div>
          </>
        ) : (
          <KajabiSubscribeEmbed
            buttonText={buttonText ? buttonText : "Get notified"}
            emailPlaceholder="Email"
          />
        )}
        
      </div>
    )
  }
}

export default withToastManager(SubscribeForm);

SubscribeForm.propTypes = {
  message: PropTypes.string,
  buttonText: PropTypes.string
}